import { useEffect, useState } from "react";
import "./style.css";

function MetaCard({ dados }) {

  const {
    indexcategoria,
    descricao,
    percgasto,
    valmeta,
    valgasto
  } = dados;

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setProgress(Math.min(percgasto, 100));
    }, 200);
  }, [percgasto]);

  const restante = valmeta - valgasto;

  const formatar = (v) =>
    v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

  const getCor = () => {
    if (percgasto >= 100) return "vermelho";
    if (percgasto >= 70) return "laranja";
    return "verde";
  };

  const corClasse = getCor();

  const getStatus = () => {
    if (percgasto >= 100) return "Meta excedida";
    if (percgasto >= 70) return "Atenção";
    return "Dentro da meta";
  };

  return (
    <div className="meta-card">

      <div className="meta-left">
        <div className="meta-icon">
          <img
            src={require(`../../assets/Categoria/${indexcategoria + 1}.png`)}
            alt="categoria"
          />
        </div>

        <div className="meta-info">
          <strong>{descricao}</strong>
          <small>
            {formatar(valgasto)} de {formatar(valmeta)}
          </small>
          <span className="meta-restante">
            Restante: {formatar(Math.max(restante, 0))}
          </span>
        </div>
      </div>

      <div className="meta-right">

        <div className={`meta-percent ${corClasse}`}>
          {percgasto.toFixed(0)}%
        </div>

        <div className="meta-bar">
          <div
            className={`meta-progress ${corClasse}`}
            style={{ width: `${progress}%` }}
          ></div>
        </div>

        <span className={`meta-status ${corClasse}`}>
          {getStatus()}
        </span>

      </div>

    </div>
  );
}

export default MetaCard;